@if (indicator; as ind) {
  @if (ind.tone === 'discreet') {
    <span class="sourtrack-sync__discreet" data-test="sourtrack-status">{{ ind.label }}</span>
    @if (canRetry) {
      <button data-test="sourtrack-retry" nz-button nzType="link" nzSize="small"
        [nzLoading]="retrying" [disabled]="retrying" (click)="retry.emit()">
        Enviar a SourTrack
      </button>
    }
  } @else {
    <nz-alert
      data-test="sourtrack-status"
      [nzType]="ind.tone"
      nzShowIcon
      [nzMessage]="ind.label"
      [nzDescription]="description"
    ></nz-alert>
    <ng-template #description>
      @if (ind.detail) {
        <div class="sourtrack-sync__detail"><strong>Detalle:</strong> {{ ind.detail }}</div>
      }
      @if (canRetry) {
        <button data-test="sourtrack-retry" nz-button nzType="primary" nzShape="round" nzSize="small"
          [nzLoading]="retrying" [disabled]="retrying" (click)="retry.emit()">
          Reintentar sincronización
        </button>
      }
    </ng-template>
  }
}
